import actionTypes from "../actionTypes";
import * as zpCVysledokVyjadreniaUtils from "../../utils/ciselniky/zpCVysledokVyjadreniaUtils";

export const changeVysledokVyjadrenia = (vysledokVyjadrenia) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_VYSLEDOK_VYJADRENIA,
      data: vysledokVyjadrenia,
    });
  };
};
const getZP_C_VYSLEDOK_VYJADRENIA_Request = () => ({
  type: actionTypes.GET_ZP_C_VYSLEDOK_VYJADRENIA_REQUEST,
});
const getZP_C_VYSLEDOK_VYJADRENIA_Success = (res) => ({
  type: actionTypes.GET_ZP_C_VYSLEDOK_VYJADRENIA_SUCCESS,
  res,
});
const getZP_C_VYSLEDOK_VYJADRENIA_Failure = (error) => ({
  type: actionTypes.GET_ZP_C_VYSLEDOK_VYJADRENIA_FAILURE,
  error,
});
export const getZP_C_VYSLEDOK_VYJADRENIA = () => {
  return async (dispatch) => {
    try {
      dispatch(getZP_C_VYSLEDOK_VYJADRENIA_Request());
      let res = await zpCVysledokVyjadreniaUtils.getZP_C_VYSLEDOK_VYJADRENIA();
      dispatch(getZP_C_VYSLEDOK_VYJADRENIA_Success(res));
    } catch (error) {
      dispatch(getZP_C_VYSLEDOK_VYJADRENIA_Failure(error));
    }
  };
};
